import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { enableDebugCapturePointerEvents } from "./portal";

/** Above StyledModal (100001), confirmation dialogs, pickers (100002). */
export const DEBUG_CAPTURE_Z = {
  pickerOverlay: 2147483638,
  backdrop: 2147483640,
  dialog: 2147483641,
  recordingIndicator: 2147483642,
  floatingButton: 2147483646
} as const;
export type DebugCaptureLayer = keyof typeof DEBUG_CAPTURE_Z;
export function applyDebugCaptureZIndex(element: HTMLElement, layer: DebugCaptureLayer): void {
  element.style.setProperty("position", "fixed", "important");
  element.style.setProperty("z-index", String(DEBUG_CAPTURE_Z[layer]), "important");
  enableDebugCapturePointerEvents(element);
}
export function useDebugCaptureLayerRef(layer) {
  const $ = _c(2);
  let t0;
  if ($[0] !== layer) {
    t0 = node => {
      if (node) {
        applyDebugCaptureZIndex(node, layer);
      }
    };
    $[0] = layer;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}